// extracted by mini-css-extract-plugin
export var closeButton = "_mw-2";
export var closeButtonIcon = "_mw-3";
export var lightboxContent = "_mw-1";
export var lightboxOverlay = "_mw-0";